export default __webpack_public_path__ + "static/media/associacao.05fd08a3.jpeg";